if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}



class DragProductInfo extends HTMLElement {
  constructor() {
    super();
    this.dragItem = this.querySelector(".product__info-grabable-icon");
    this.productInfo = this;
    this.active = false;
    this.currentY = 0;
    this.initialY = 0;
    this.yOffset = 0;
    this.overlay = this.querySelector(
      ".rocket-main-product__buy-buttons-wrapper .rocket-product-card__overlay"
    );
    this.closeCartBtn = this.querySelector(
      ".rocket-main-product__buy-buttons-wrapper .rocket-product-card__size-close"
    );
    this.scalpersSliderComponentEl = document.querySelector(
      ".grid__item.product__media-wrapper"
    );
    this.cartDrawer = document.querySelector("cart-drawer");
    this.initEvents();
    let optionList = this.querySelectorAll(
      "card-variant-radios .product-form__input input[name='size']"
    );
    this.colorPickerEl = this.querySelector(
      ".rocket-main-product__title-color-picker"
    );

    this.overlay.addEventListener("click", () => {
      this.closeModal();
    });

    this.closeCartBtn.addEventListener("click", () => {
      this.closeModal();
    });

    this.colorPickerEl.addEventListener("click", () => {
      this.classList.toggle("color-picker-toggled");
    });
    this.querySelectorAll("variant-swiper").forEach((el) => el.init());
  }

  closeModal() {
    document.querySelector("body").style.overflowY = "unset";
    this.overlay.style.display = "none";
  }

  initEvents() {
    this.dragItem.addEventListener(
      "touchstart",
      (event) => this.dragStart(event),
      false
    );
    this.dragItem.addEventListener(
      "touchend",
      (event) => this.dragEnd(),
      false
    );
    this.dragItem.addEventListener(
      "touchmove",
      (event) => this.dragMove(event),
      false
    );

    this.dragItem.addEventListener(
      "mousedown",
      (event) => this.dragStart(event),
      false
    );
    this.dragItem.addEventListener("mouseup", (event) => this.dragEnd(), false);
    this.dragItem.addEventListener(
      "mousemove",
      (event) => this.dragMove(event),
      false
    );

    document.addEventListener(
      "gallery:swipe-end",
      () => {
        const dragProductInfo = new DragProductInfo();
        dragProductInfo.openInfo();
      },
      false
    );
  }

  openInfo() {
    this.productInfo.classList.add("is-active", "transition");
    document.querySelector("body").classList.add("drag-info-active");
  }

  dragStart(event) {
    if (event.type === "touchstart") {
      this.initialY = event.touches[0].clientY;
    } else {
      this.initialY = event.clientY;
    }

    this.active = true;
  }

  dragEnd() {
    this.initialY = this.currentY;
    this.active = false;

    if (this.currentY > 100) {
      if (this.productInfo.classList.contains("first-time")) {
        this.productInfo.classList.remove("is-active");
        document.querySelector("body").classList.remove("drag-info-active");
      } else {
        this.productInfo.classList.add("first-time");
      }
      this.scalpersSliderComponentEl.classList.remove("overflow-hidden");
    } else if (this.currentY < -80) {
      this.productInfo.classList.add("is-active");
      document.querySelector("body").classList.add("drag-info-active");
      this.scalpersSliderComponentEl.classList.add("overflow-hidden");
      this.classList.remove("color-picker-toggled");
      if (this.productInfo.classList.contains("first-time")) {
        this.productInfo.classList.remove("first-time");
      } else {
        this.productInfo.classList.add("first-time");
      }
    } else {
      this.productInfo.classList.add("is-active");
      document.querySelector("body").classList.add("drag-info-active");
      this.productInfo.classList.add("first-time");
    }

    this.productInfo.style.transform = "";
    this.currentY = 0;

    this.setTranslate();

    this.productInfo.classList.add("transition");

    setTimeout(() => {
      this.productInfo.classList.remove("transition");
    }, 450);
  }

  dragMove(event) {
    if (!this.active) {
      return;
    }
    event.preventDefault();
    if (event.type === "touchmove") {
      this.currentY = event.touches[0].clientY - this.initialY;
    } else {
      this.currentY = event.clientY - this.initialY;
    }
    this.yOffset = this.currentY;
    this.setTranslate();
  }

  setTranslate() {
    if (this.productInfo.classList.contains("is-active")) {
      this.productInfo.style.transform = `translate3d(0, ${this.currentY}px, 0)`;
    } else {
      this.productInfo.style.transform = `translate3d(0, ${this.currentY}px, 0)`;
    }

    if (this.currentY == 0) {
      this.productInfo.style.transform = "unset";
    }
  }
}

// customElements.define("drag-product-info", DragProductInfo);

function scrollToTargetAdjusted() {
  let element = document.querySelector('.product__info-grabable-icon');
  let headerOffset = document.querySelector('.gigi-header-container').offsetHeight;
  let annoucementOffset = document.querySelector('.announcement-bar-section').offsetHeight;
  let elementPosition = element.getBoundingClientRect().top;
  let offsetPosition = elementPosition + window.pageYOffset - headerOffset + annoucementOffset;

  window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
  });   
}